export default "__VITE_ASSET__V85zn4tJ__$_?nuxt_component=async&nuxt_component_name=IconFrameShapeMehreckig&nuxt_component_export=default__"